enum Focus {
  ACCOUNT, // 0
  ADS, // 1
  CHANNELS_CHOICE, // 2
  CHANNEL_GUIDE_LOGO, // 3
  CHANNEL_LIST, // 4
  CHANNEL_LIST_EVENTS, // 5
  CHANNEL_LIST_UPGRADE, // 6
  DETAIL_BUTTONS, // 7
  DETAIL_RELATED, // 8
  DETAIL_SYNOPSIS, // 9
  DISK, // 10
  FLOATING_MENU, // 11
  LANGUAGES, // 12
  LIST_BUTTONS, // 13
  LOGIN, // 14
  LOGOUT, // 15
  MAIN_EMPTY, // 16
  MANAGE_CHANNELS_BUTTONS, // 17
  MENU, // 18
  MODAL_BUTTONS, // 19
  MODAL_INPUT, // 20
  MODAL_LANGUAGE_AUDIO, // 21
  MODAL_LANGUAGE_SUBTITLES, // 22
  MODAL_ZOOM, // 23
  MOSAIC, // 24
  NEXT_EPISODE, // 25
  PAUSE_ADS, // 26
  PLAYER, // 27
  POWER_SAVING, // 28
  PROMO, // 29
  QUERY_LIST, // 30
  RAILS_LIST, // 31
  RAILS_SUB_LIST, // 32
  SEARCH, // 33
  SEARCH_KEYBOARD, // 34
  SLIDER_LIST, // 35
  SLIDER_SUB_LIST, // 36
  SLIDERS, // 37
  SPLASH, // 38
  WEBVIEW, // 39
  ZAPPER, // 40
  ZAPPER_HINT, // 41
}

export default Focus;
